module.exports = "precision mediump float;\n#define GLSLIFY 1\n\nvoid main() {\n    gl_FragColor = vec4(0.79, 0.79, 0.79, 1.0);\n}"